import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "@mui/material";

// const fetchCryptoData = async () => {
// 	const url = "https://api.coinpaprika.com/v1/tickers";
// 	const response = await fetch(url);

// 	if (!response.ok) {
// 		throw new Error("Network response was not ok");
// 	}

// 	return response.json();
// };

function createData(name, calories, fat, carbs, protein, price) {
	return {
		name,
		calories,
		fat,
		carbs,
		protein,
		price,
		history: [
			{
				date: "2020-01-05",
				customerId: "11091700",
				amount: 3,
			},
			{
				date: "2020-01-02",
				customerId: "Anonymous",
				amount: 1,
			},
		],
	};
}

function Row(props) {
	const { row } = props;
	const [open, setOpen] = React.useState(false);

	return (
		<React.Fragment>
			<TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
				<TableCell>
					<IconButton
						aria-label="expand row"
						size="small"
						onClick={() => setOpen(!open)}>
						{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
					</IconButton>
				</TableCell>
				<TableCell component="th" scope="row">
					{row.name}
				</TableCell>
				<TableCell align="right">{row.symbol}</TableCell>
				<TableCell align="right">{row.rank}</TableCell>
				<TableCell align="right">{row.total_supply}</TableCell>
				<TableCell align="right">{row.max_supply}</TableCell>
			</TableRow>
			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box sx={{ margin: 1 }}>
							<Typography variant="h6" gutterBottom component="div">
								History
							</Typography>
							<Table size="small" aria-label="purchases">
								<TableHead>
									<TableRow>
										<TableCell>Price</TableCell>
										<TableCell>Market Cap</TableCell>
										<TableCell align="right">24hr market cap change </TableCell>
										<TableCell align="right">24hr volume change</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{/* {row.quotes.map((historyRow) => ( */}
									<TableRow key={row.id}>
										<TableCell component="th" scope="row">
											{row.quotes.USD.price}
										</TableCell>
										<TableCell>{row.quotes.USD.market_cap}</TableCell>
										<TableCell align="right">
											{row.quotes.USD.market_cap_change_24h}
										</TableCell>
										<TableCell align="right">
											{row.quotes.USD.volume_24h}
										</TableCell>
									</TableRow>
									{/* ))} */}
								</TableBody>
							</Table>
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</React.Fragment>
	);
}

Row.propTypes = {
	row: PropTypes.shape({
		calories: PropTypes.number.isRequired,
		carbs: PropTypes.number.isRequired,
		fat: PropTypes.number.isRequired,
		history: PropTypes.arrayOf(
			PropTypes.shape({
				amount: PropTypes.number.isRequired,
				customerId: PropTypes.string.isRequired,
				date: PropTypes.string.isRequired,
			})
		).isRequired,
		name: PropTypes.string.isRequired,
		price: PropTypes.number.isRequired,
		protein: PropTypes.number.isRequired,
	}).isRequired,
};

// const rows = [
// 	createData("Frozen yoghurt", 159, 6.0, 24, 4.0, 3.99),
// 	createData("Ice cream sandwich", 237, 9.0, 37, 4.3, 4.99),
// 	createData("Eclair", 262, 16.0, 24, 6.0, 3.79),
// 	createData("Cupcake", 305, 3.7, 67, 4.3, 2.5),
// 	createData("Gingerbread", 356, 16.0, 49, 3.9, 1.5),
// ];

// export default function CryptoTableUtil() {
// 	const { data, error, isLoading } = useQuery({
// 		queryKey: ["cryptoData"],
// 		queryFn: fetchCryptoData,
// 	});
// 	const [mainData, setMainData] = React.useState();
// 	React.useEffect(() => {
// 		const checkData = () => {
// 			if (error) {
// 				console.log(error);
// 			}

// 			if (data) {
// 				setMainData(Array.isArray(data) ? data : Object.values(data));
// 			}

// 			if (isLoading) {
// 				console.log(isLoading);
// 			}

// 			console.log(typeof mainData?.data);

// 			// const dt =
// 			// 	typeof data === "undefined" ? "loading..." : Object.values(data);
// 			// console.log(
// 			// 	typeof data === "undefined" ? "loading..." : typeof Object.values(data)
// 			// );

// 			//   const dt =  typeof resData === "undefined" ? "loading..." : typeof resData
// 			// 	console.log(
// 			// 	);
// 		};

// 		checkData();
// 	}, [data, error, mainData]);

// 	return (
// 		<TableContainer component={Paper}>
// 			<Table aria-label="collapsible table">
// 				<TableHead>
// 					<TableRow>
// 						<TableCell />
// 						<TableCell>Crypto name</TableCell>
// 						<TableCell align="right">Symbol</TableCell>
// 						<TableCell align="right">Rank</TableCell>
// 						<TableCell align="right">Total supply</TableCell>
// 						<TableCell align="right">Maximum supply</TableCell>
// 					</TableRow>
// 				</TableHead>
// 				<TableBody>
// 					{rows.map((row) => (
// 						<Row key={row.name} row={row} />
// 					))}
// 				</TableBody>
// 			</Table>
// 		</TableContainer>
// 	);
// }

// import React from 'react';
// import { useQuery } from 'react-query'; // Ensure you have the react-query imported
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material'; // Adjust according to your MUI version
// import Row from './Row'; // Ensure Row component is imported correctly

const fetchCryptoData = async () => {
	const response = await fetch("https://api.coinpaprika.com/v1/tickers");
	if (!response.ok) {
		throw new Error("Network response was not ok");
	}
	return await response.json(); // Assuming the API returns JSON
};

export default function CryptoTableUtil() {
	const { data, error, isLoading } = useQuery({
		queryKey: ["cryptoData"],
		queryFn: fetchCryptoData,
	});

	// Return early if the data is loading or if there's an error
	if (isLoading) {
		// return <div>Loading...</div>;

		return (
			<TableContainer component={Paper}>
				<Table>
					<TableBody>
						{Array.from(new Array(5)).map((_, index) => (
							<TableRow key={index}>
								<TableCell>
									<Skeleton variant="rectangular" width={40} height={40} />
								</TableCell>
								<TableCell>
									<Skeleton variant="text" width="100%" />
								</TableCell>
								<TableCell>
									<Skeleton variant="text" width="60%" />
								</TableCell>
								<TableCell>
									<Skeleton variant="text" width="40%" />
								</TableCell>
								<TableCell>
									<Skeleton variant="text" width="40%" />
								</TableCell>
								<TableCell>
									<Skeleton variant="text" width="40%" />
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		);
	}

	if (error) {
		console.error("Error fetching data:", error);
		return <div>Error: {error.message}</div>;
	}

	// Assuming the data is an array of objects representing tickers
	const rows = Array.isArray(data) ? data : Object.values(data);

	console.log({ rw: rows });
	// console.log(mainData);

	return (
		<TableContainer component={Paper}>
			<Table aria-label="collapsible table">
				<TableHead>
					<TableRow>
						<TableCell />
						<TableCell>Crypto Name</TableCell>
						<TableCell align="right">Symbol</TableCell>
						<TableCell align="right">Rank</TableCell>
						<TableCell align="right">Total Supply</TableCell>
						<TableCell align="right">Maximum Supply</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{rows?.map((row) => (
						<Row key={row.id} row={row} /> // Assuming row has a unique 'id'
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
